import { createStore, Action, createHook } from 'react-sweet-state';

type ConsentBannerState = {
  consentBannerHeight: number;
};

// Initial State
const initialState: ConsentBannerState = {
  consentBannerHeight: 0,
};

// Actions
const setConsentBannerHeight =
  (height: number): Action<ConsentBannerState> =>
  ({ setState }) => {
    setState({ consentBannerHeight: height });
  };

const actions = {
  setConsentBannerHeight,
};

const ConsentBannerStore = createStore({
  initialState,
  actions,
});

export const useConsentBanner = createHook(ConsentBannerStore);
